"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Categoria = void 0;
var categoriaModule = require('./Categoria.module.scss');
var react_1 = __importStar(require("react"));
var Icone_1 = require("../Icone/Icone");
var Categoria = function (_a) {
    var _b = _a.valor, valor = _b === void 0 ? '' : _b, _c = _a.opcoes, opcoes = _c === void 0 ? [] : _c, onCategoriaSelecionada = _a.onCategoriaSelecionada;
    var _d = (0, react_1.useState)(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = (0, react_1.useState)(valor), valorSelecionado = _e[0], setValorSelecionado = _e[1];
    var menuRef = react_1.default.useRef(null);
    var categoriaRef = react_1.default.useRef(null);
    var handleSelect = function (value) {
        onCategoriaSelecionada(value);
        setValorSelecionado(value);
        toggleMenu();
    };
    var handleClickOutside = function (event) {
        if (menuRef.current &&
            categoriaRef.current &&
            !menuRef.current.contains(event.target) &&
            !categoriaRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };
    var toggleMenu = function () {
        setIsOpen(!isOpen);
    };
    (0, react_1.useEffect)(function () {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);
    var renderSelectedValue = function () {
        return (react_1.default.createElement("div", { className: "".concat(valorSelecionado.length > 0 ? categoriaModule.inputSelect : categoriaModule.placeholder), onClick: toggleMenu },
            valorSelecionado && valorSelecionado,
            !valorSelecionado && 'Categoria'));
    };
    var renderMoreButton = function () {
        return (react_1.default.createElement("div", { className: "".concat(categoriaModule.expandButton), onClick: toggleMenu },
            react_1.default.createElement(Icone_1.Icone, { nome: isOpen ? 'expand_less' : 'expand_more', largura: "24px", altura: "24px" })));
    };
    var renderMenuCategorias = function () {
        return (react_1.default.createElement("div", { ref: menuRef, className: "".concat(categoriaModule.menu, " ").concat(isOpen ? categoriaModule.active : '') },
            react_1.default.createElement("h3", null, "CATEGORIAS"),
            react_1.default.createElement("div", { className: categoriaModule.menuDivider }),
            react_1.default.createElement("div", { className: "".concat(categoriaModule.listaCategorias) }, opcoes.map(function (categoria, index) { return (react_1.default.createElement("div", { key: index, onClick: function () { return handleSelect(categoria); }, className: "".concat(categoriaModule.categoriaItem, " ") }, categoria)); }))));
    };
    return (react_1.default.createElement("div", { ref: categoriaRef, className: "".concat(categoriaModule.categoria) },
        react_1.default.createElement("div", { className: categoriaModule.valueArea, onClick: toggleMenu },
            react_1.default.createElement("h4", null, "CATEGORIA:"),
            renderSelectedValue(),
            renderMoreButton()),
        renderMenuCategorias()));
};
exports.Categoria = Categoria;
